<template>
  <div :class="[ baseClass, padding, { 'items-center' : center }]">
    <dt :class="[ termClass, termCol ]">
      <slot name="term">
        {{ date && dateFormat ? `${term} (${dateFormat})` : term }}
      </slot>
    </dt>
    <dd :class="[ definitionClass, definitionCol, { 'text-right' : alignRight } ]">
      <slot />
    </dd>
  </div>
</template>

<script lang="ts">
export default { name: 'ODescriptionDetails' }
</script>

<script setup lang="ts">
const { $i18n } = useNuxtApp()

interface Props {
  term?: string | null
  baseClass?: string
  termClass?: string
  definitionClass?: string
  termCol?: string
  definitionCol?: string
  center?: boolean
  alignRight?: boolean
  padding?: string
  date?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  term: null,
  baseClass: 'sm:grid sm:grid-cols-6 sm:gap-1',
  termClass: 'text-sm leading-5 opacity-80',
  definitionClass: 'mt-1 text-sm leading-5 sm:mt-0',
  termCol: 'sm:col-span-1',
  definitionCol: 'sm:col-span-5',
  center: false,
  alignRight: false,
  padding: 'py-3',
  date: false,
})

const dateFormat = computed(() => {
  if (!props.date) return ''
  const locale = $i18n.locale.value || 'en'
  const sample = new Date(2000, 0, 15)
  const formatted = new Intl.DateTimeFormat(locale, { year: 'numeric', month: '2-digit', day: '2-digit' }).format(sample)
  return formatted.replace('2000', 'YYYY').replace('01', 'MM').replace('15', 'DD')
})
</script>
